import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { map, Observable, take } from 'rxjs';
import { isEmptyArray } from '../../services/common-utils/common-utils';

@Injectable()
export class AuthorizeService {

  constructor(private readonly router: Router,
    private readonly user: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const expectedRoles: string[] = route.data["expectedRoles"];
    const isStrictMode: boolean = route.data["isStrictMode"];

    return this.user.getUser().pipe(
      take(1),
      map(user => {
        if (isEmptyArray(user.roles)) {
          return this.router.parseUrl('/access-denied');
        }
        const isAllowed = isStrictMode ?
          expectedRoles.every(role => user.roles.includes(role)) :
          expectedRoles.some(role => user.roles.includes(role));
        return isAllowed ? true : this.router.parseUrl('/access-denied');
      })
    );
  }
}

export const authorizeGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  return inject(AuthorizeService).canActivate(route, state);
};
